export const FLOATING_BODY_PATH = 'studio/aida/character/aida-floating-body-v2.glb'

const files = new Map<string, Promise<ArrayBuffer>>()

export function prefetchMascotModel(url: string) {
  let file = files.get(url)
  if (!file) {
    file = fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Mascot model failed to load (${response.status})`)
        }
        return response.arrayBuffer()
      })
      .catch(error => {
        files.delete(url)
        throw error
      })
    files.set(url, file)
  }
  return file
}
